/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"
import { Grid, Spacer, TextGroupLarge, useMediaQuery } from "@cd2/components"
import { EOSBreadcrumb, IBreadcrumb } from "./EOSBreadcrumb"
import { FloatingBottomActions } from "./FloatingBottomActions"
import { ButtonsWrapper } from "./ButtonsWrapper"
import { PageHelmet } from "./PageHelmet"

interface IPageWrapperProps {
  children: React.ReactNode
  breadcrumbPath?: IBreadcrumb
  title: string
  subtitle?: string | React.ReactNode
  pageActions?: () => React.ReactNode
  bottomActions?: () => React.ReactNode
  underTitleNode?: React.ReactNode
  minWidth?: number
  dontPadChildren?: boolean
}

export function PageWrapper({
  children,
  breadcrumbPath,
  title,
  pageActions,
  bottomActions,
  underTitleNode,
  minWidth,
  subtitle,
  dontPadChildren,
}: IPageWrapperProps) {
  const isSmall = useMediaQuery({ maxWidth: 768 })

  return (
    <div
      css={css`
        padding: 24px 24px;
      `}
    >
      {title && <PageHelmet>{title}</PageHelmet>}
      <div>
        {breadcrumbPath && (
          <React.Fragment>
            <EOSBreadcrumb path={breadcrumbPath} />
            <Spacer size={16} />
          </React.Fragment>
        )}

        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
          `}
        >
          <div
            css={css`
              flex: 1;
            `}
          >
            <TextGroupLarge heading={title} body={subtitle} theme={{ body: { size: "normal" } }} />
            <Spacer />
            {isSmall && pageActions && (
              <React.Fragment>
                <ButtonsWrapper>{pageActions()}</ButtonsWrapper>
                <Spacer />
              </React.Fragment>
            )}
            {underTitleNode}
          </div>
          {!isSmall && pageActions && (
            <div>
              <ButtonsWrapper
                css={css`
                  justify-content: right;
                `}
              >
                {pageActions()}
              </ButtonsWrapper>
            </div>
          )}
        </div>
        <Spacer size={24} />
        <div
          css={
            dontPadChildren
              ? css`
                  margin: 0 -24px;
                `
              : undefined
          }
        >
          <div
            css={
              minWidth
                ? css`
                    max-width: 100%;
                    overflow-x: auto;
                  `
                : undefined
            }
          >
            <div
              css={
                minWidth
                  ? css`
                      min-width: ${minWidth}px;
                      width: calc(100% - 1px);
                    `
                  : undefined
              }
            >
              <Grid gap={16}>{children}</Grid>
            </div>
          </div>
        </div>
        <Spacer size={80} />
      </div>
      {bottomActions && <FloatingBottomActions>{bottomActions()}</FloatingBottomActions>}
    </div>
  )
}
